<template>
  <div class="flex flex-col items-center justify-center gap-4 sm:gap-6 py-8 sm:py-12">
    <!-- Success Card -->
    <div class="bg-white rounded-xl shadow-md p-4 sm:p-6 flex flex-col items-center gap-4 sm:gap-6 max-w-md w-full">
      <!-- Green Checkmark Icon -->
      <svg class="w-14 h-14 sm:w-16 sm:h-16 text-green-500" viewBox="0 0 24 24" fill="none">
        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" fill="none"/>
        <path d="M8 12l3 3 5-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>

      <!-- Text Content -->
      <div class="flex flex-col gap-3 sm:gap-4 text-center">
        <h2 class="text-2xl sm:text-3xl font-bold text-gray-900 text-balance">
          Check-in success!
        </h2>
        <p class="text-base font-medium text-gray-600 leading-6 text-pretty break-words">
          <span class="font-bold">{{ wrestlerName }}</span>
          <span> is now checked-in to the </span>
          <span class="font-bold">{{ eventDescription }}</span>
        </p>
      </div>

      <!-- Trial/Drop-in Pass Badge -->
      <div v-if="isTrialPass" class="flex items-center gap-2 px-4 py-2 bg-green-100 text-green-800 rounded-lg">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
        <span class="font-medium">Trial pass used</span>
      </div>
      <div v-else-if="isDropInPass" class="flex items-center gap-2 px-4 py-2 bg-blue-100 text-blue-800 rounded-lg">
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"/>
        </svg>
        <span class="font-medium">Drop-in pass used</span>
      </div>
    </div>

    <!-- Countdown Text -->
    <p class="text-lg sm:text-xl font-medium text-gray-600 text-center">
      Returning to home screen in
    </p>

    <!-- Countdown Number -->
    <p class="text-5xl sm:text-6xl font-normal text-gray-600 tabular-nums">
      {{ countdown }}...
    </p>

    <!-- Manual Return Button -->
    <button
      @click="$emit('return-home')"
      class="px-6 py-3 rounded-lg font-semibold text-base whitespace-nowrap"
      style="background-color: var(--team-primary); color: var(--team-text);"
    >
      Return to home now
    </button>
  </div>
</template>

<script>
export default {
  name: 'KioskCheckInSuccess',
  props: {
    wrestler: {
      type: Object,
      required: true,
    },
    event: {
      type: Object,
      required: true,
    },
    checkIn: {
      type: Object,
      default: null,
    },
    autoReturnSeconds: {
      type: Number,
      default: 2,
    },
  },
  emits: ['return-home'],
  data() {
    return {
      countdown: this.autoReturnSeconds,
      countdownInterval: null,
    };
  },
  computed: {
    wrestlerName() {
      return this.wrestler?.display_name || this.wrestler?.full_name || 'Wrestler';
    },
    eventDescription() {
      if (!this.event || this.event.id === -1) {
        return 'General Check-in';
      }

      const time = this.formatEventTime(this.event);
      const name = this.event.name || 'event';

      if (time) {
        return `${time} ${name}`;
      }
      return name;
    },
    sessionType() {
      return this.checkIn?.class_pass?.paid_session?.session_type;
    },
    isTrialPass() {
      return this.sessionType === 'trial';
    },
    isDropInPass() {
      return this.sessionType === 'dropin';
    },
  },
  mounted() {
    this.startCountdown();
  },
  beforeDestroy() {
    this.clearCountdown();
  },
  methods: {
    formatEventTime(event) {
      if (!event || event.id === -1) return '';

      if (event.all_day) {
        return '';
      }

      const start = moment(event.start_at);
      return start.format('h:mm A');
    },
    startCountdown() {
      this.countdownInterval = setInterval(() => {
        this.countdown -= 1;
        if (this.countdown <= 0) {
          this.clearCountdown();
          this.$emit('return-home');
        }
      }, 1000);
    },
    clearCountdown() {
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }
    },
  },
};
</script>
